export default __webpack_public_path__ + "static/media/sescon.4a6f152c.png";